<template>

</template>

<script>
import http from "../lib/http";

export default {
    name: 'Index',
    beforeCreate() {
        this.$router.push('/bank-index');
        // const self = this;
        // http({
        //     method: "post",
        //     url: "/org/user/get",
        //     data: ""
        // }).then(function(res){
        //     if(res.data.org_type_id ==1){
                
        //         self.$router.push('/bank-index');
        //     }else if(res.data.org_type_id==2){

        //     }
        // }).catch(function(err){

        // });

    }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/index.vue